<template>
  <div class="home">
    <!-- banner -->
    <div class="home-banner-box">
      <div class="home-banner">
        <!-- <div class="website-intro">
          <div class="website-intro-box">
            牛法顾是一家专注于为客户提供企业法律顾问服务、私人法律顾问服务、专项服务的平台，牛法顾已与上海锦天城律师事务所等国内一线律所建立了战略合作关系，由专业律师团队为客户提供优质的法律解决方案</div>
        </div> -->
        <div class="swiper-container-box">
          <swiper :options="swiperOption" ref="mySwiper" style="width: 100%;height: 100%;">
            <!-- 企业 -->
            <swiper-slide style="width: 100%;height: 100%;">
              <div class="home-banner-content-box">
                <img src="@/assets/home/bgs52.png" alt="">
                <div class="home-banner-content">
                  <div class="home-banner-content-desc">
                    <div class="home-banner-content-desc-title">资深律师团队构筑企业风险控制体系</div>
                    <div class="home-banner-content-desc-text">通过电话或在线交流就企业法律主题（例如公司设立、投资、合同审查、招聘和合规）获得有价值的法律服务。</div>
                    <div class="home-banner-content-desc-button">
                      <div class="left">
                        <RegionSelect v-model="selectedRegion" @change="handleRegionChange" />
                      </div>
                      <div class="right" @click="handleGoPackClick('COMPANY')">开始您的企业法律顾问套餐服务</div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <!-- 个人 -->
            <swiper-slide style="width: 100%;height: 100%;">
              <div class="home-banner-content-box">
                <img src="@/assets/home/bgs50.png" alt="">
                <div class="home-banner-content">
                  <div class="home-banner-content-desc">
                    <div class="home-banner-content-desc-title">资深律师团队守护个人权益与财富安全</div>
                    <div class="home-banner-content-desc-text">通过电话或在线交流的方式就个人法律主题（例如遗产规划、继承、婚姻、就业、房地产、金融）获得有价值的法律服务。
                    </div>
                    <div class="home-banner-content-desc-button">
                      <div class="left">
                        <RegionSelect v-model="selectedRegion" @change="handleRegionChange" />
                      </div>
                      <div class="right" @click="handleGoPackClick('USER')">开始您的私人法律顾问套餐服务</div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <!-- 专项定制 -->
            <swiper-slide style="width: 100%;height: 100%;">
              <div class="home-banner-content-box">
                <img src="@/assets/home/bgs51.png" alt="">
                <div class="home-banner-content">
                  <div class="home-banner-content-desc">
                    <div class="home-banner-content-desc-title">精准法务导航，定制专项服务体系</div>
                    <div class="home-banner-content-desc-text">通过电话或在线交流就企业和个人法律主题（例如公司设立、投资、遗产规划、继承）获得有价值的法律服务。</div>
                    <div class="home-banner-content-desc-button">
                      <div class="left">
                        <RegionSelect v-model="selectedRegion" @change="handleRegionChange" />
                      </div>
                      <div class="right" @click="handleGoPackClick('MADE')">开始您的专项法律服务</div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <!-- 添加分页器 -->
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- 添加前进后退按钮 -->
            <div class="swiper-button-prev" slot="button-prev">
              <img src="@/assets/home/zuo.png" alt="">
            </div>
            <div class="swiper-button-next" slot="button-next">
              <img src="@/assets/home/you.png" alt="">
            </div>
          </swiper>
        </div>


      </div>
    </div>

    <!-- 为什么选择牛法顾私人法律顾问套餐服务？ -->
    <div class="home-why-choose-box">
      <div class="home-why-choose">
        <div class="home-why-choose-title">为什么选择牛法顾法律顾问套餐服务？</div>
        <div class="home-why-choose-content">
          <div class="home-why-choose-content-item">
            <div class="home-why-choose-content-item-img"></div>
            <div class="home-why-choose-content-item-title">可预测、实惠的价格</div>
            <div class="home-why-choose-content-item-text">
              您可以在预算范围内以可预测的价格获得所需的法律帮助。客户可以无限制地就法律主题进行一定时间的通话，每月费用实惠，由专业的律师为您提供服务。</div>
          </div>
          <div class="home-why-choose-content-item">
            <div class="home-why-choose-content-item-img"></div>
            <div class="home-why-choose-content-item-title">无忧无虑的便利性</div>
            <div class="home-why-choose-content-item-text">我们有值得信赖的律师网络，随时指导您逐步解决最基本的法律需求，无需准备——安排咨询是一件轻而易举的事。</div>
          </div>
          <div class="home-why-choose-content-item">
            <div class="home-why-choose-content-item-img"></div>
            <div class="home-why-choose-content-item-title">值得信赖的经验</div>
            <div class="home-why-choose-content-item-text">为客户提供服务的律师，都经过我们的认真审查，拥有丰富的经验和满意的评分——知道如何处理法律事务。</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择您的私人法律顾问套餐 -->
    <!-- <div class="home-choose-private-lawyer-box">
      <div class="home-choose-private-lawyer-bg">
        <div class="home-choose-private-lawyer">
          <div class="home-choose-private-lawyer-title">选择您的私人法律顾问套餐</div>
          <div class="home-choose-private-lawyer-content">
            <div class="home-choose-private-lawyer-content-item" v-for="(item, index) in comboList" :key="index">
              <div class="home-choose-private-lawyer-content-item-user">{{ type == 0 ? '企业' : '个人' }}法律顾问</div>
              <div class="home-choose-private-lawyer-content-item-title">{{ item.comboName || '' }}</div>
              <div class="home-choose-private-lawyer-content-item-price">
                <div class="home-choose-private-lawyer-content-item-price-top">￥{{ item.price | money }}
                </div>
                <div class="home-choose-private-lawyer-content-item-price-bottom">基础套餐价</div>
              </div>
              <div class="home-choose-private-lawyer-content-item-area">
                <RegionSelect v-model="item.selectArea" @change="(val) => { handleRegionChangeForCombo(val, item) }" />
              </div>
              <div class="home-choose-private-lawyer-content-item-button" @click="handlePrivateLawyerClick(item)">
                开始您的私人顾问套餐服务</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 视频介绍 -->
    <!-- <div class="home-video-box">
      <div class="home-video">
        <div class="home-video-content">
          <div class="home-video-content-item">
            <div class="home-video-content-item-des">
              <div class="home-video-content-item-des-title">我们的{{ comboDetail1?.comboName }}包括</div>
              <div class="home-video-content-item-des-text">
                <div class="home-video-content-item-des-text-item">
                  <div class="home-video-content-item-des-text-item-title">基础服务：</div>
                  <div class="home-video-content-item-des-text-item-text"
                    v-for="(item, index) in comboDetail1?.comboServersBase" :key="index">
                    <span style="font-weight: bold;">{{ item.title || '' }}</span>：{{ item.context || '' }}
                  </div>
                </div>
                <div class="home-video-content-item-des-text-item">
                  <div class="home-video-content-item-des-text-item-title">定制服务：</div>
                  <div class="home-video-content-item-des-text-item-text">
                    在基础服务内容的基础上，用户可在套餐中自行定制其他专项服务，专项服务另行计费，但用户可享受{{ comboDetail1?.inBl }}%优惠。</div>
                  <div class="home-video-content-item-des-text-item-text">在顾问套餐之外单独选择其他专项法律服务的，套餐用户需要额外付费，但可享受
                    {{ comboDetail1?.outBl }}%优惠
                  </div>
                </div>
              </div>
            </div>
            <div class="home-video-content-item-video"></div>
          </div>

          <div class="home-video-content-item" style="margin-top: 66px;">
            <div class="home-video-content-item-video"></div>
            <div class="home-video-content-item-des">
              <div class="home-video-content-item-des-title">我们的{{ comboDetail2?.comboName }}包括 </div>
              <div class="home-video-content-item-des-text">
                <div class="home-video-content-item-des-text-item">
                  <div class="home-video-content-item-des-text-item-title">基础服务：</div>
                  <div class="home-video-content-item-des-text-item-text"
                    v-for="(item, index) in comboDetail2?.comboServersBase" :key="index">
                    <span style="font-weight: bold;">{{ item.title || '' }}</span>：{{ item.context || '' }}
                  </div>
                </div>
                <div class="home-video-content-item-des-text-item">
                  <div class="home-video-content-item-des-text-item-title">定制服务：</div>
                  <div class="home-video-content-item-des-text-item-text">
                    在基础服务内容的基础上，用户可在套餐中自行定制其他专项服务，专项服务另行计费，但用户可享受{{ comboDetail2?.inBl }}%优惠</div>
                  <div class="home-video-content-item-des-text-item-text">在顾问套餐之外单独选择其他专项法律服务的，套餐用户需要额外付费，但可享受{{
                    comboDetail2?.outBl }}%优惠。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 律师信息 -->
    <div class="home-lawyer-info-box">
      <div class="home-lawyer-info">
        <div class="home-lawyer-info-center">
          <div class="home-lawyer-info-center-title">经验丰富的律师，健全的法律指导</div>
          <div class="home-lawyer-info-center-text">为客户提供服务的律师，均来自上海市锦天城事务所等国内知名律所</div>
          <div class="home-lawyer-info-center-list">
            <div class="home-lawyer-info-center-list-item" v-for="(item,index) in lList" :key="index">
              <div class="home-lawyer-info-center-list-item-img">
                <img :src="item.lsImage" alt="">
              </div>
              <div class="home-lawyer-info-center-list-item-description">
                {{ item.lsContext }}
              </div>
            </div>

            <!-- <div class="home-lawyer-info-center-list-item">
              <div class="home-lawyer-info-center-list-item-img">
                <img src="@/assets/home/man2.png" alt="">
              </div>
              <div class="home-lawyer-info-center-list-item-description">
                我努力帮助人们解决他们的问题。我一直在上海从事法律工作，拥有丰富的经验。我明白如何处理法律事务，并为我的客户找到最具成本效益的解决方案。
              </div>
            </div> -->

            <!-- <div class="home-lawyer-info-center-list-item">
              <div class="home-lawyer-info-center-list-item-img">
                <img src="@/assets/home/man3.png" alt="">
              </div>
              <div class="home-lawyer-info-center-list-item-description">
                我是一名专业的民商事律师，在法律顾问、公司法务、房地产等领域具有丰富的经验，我的服务获得了客户的高度认可，我希望用我的专业知识帮助每一位客户。
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 服务步骤 -->
    <div class="home-service-step-box">
      <div class="home-service-step">
        <!-- 步骤 -->
        <div class="home-service-step-title">如何通过 3 个简单的步骤开始获得法律帮助</div>
        <div class="home-service-step-content1">
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/one.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">选择顾问套餐</div>
            <div class="home-service-step-content-item-text">根据您的预算和需求，选择合适的顾问套餐，以一种可预测、实惠的价格获得经验丰富的律师的帮助。
            </div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/two.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">安排律师</div>
            <div class="home-service-step-content-item-text">我们已经彻底审查了我们网络中的每一位律师，会根据您的需要，为您安排专业的律师。</div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/three.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">获得您需要的帮助</div>
            <div class="home-service-step-content-item-text">您可以通过本网站、小程序与律师取得联系，律师将准备好讨论您的第一个法律问题并作出回答，及在线提供您所需的其他套餐服务。
            </div>
          </div>
        </div>

        <!-- 按钮 -->
        <div class="home-service-step-content-button">
          <div class="home-service-step-content-button-item">
            <div class="home-service-step-content-button-item-left">
              <el-select v-model="selectedServiceType" placeholder="请选择服务类型" style="width: 100%" class="custom-select">
                <el-option v-for="item in serviceTypes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="home-service-step-content-button-item-right" @click="handlePrivateLawyerClick()">
              开始您的法律顾问服务</div>
          </div>
        </div>

        <!-- 套餐介绍 -->
        <div class="home-service-step-content-package-intro">
          <div class="home-service-step-content-package-intro-left">
            <img src="@/assets/home/bgs89.png" alt="">
          </div>
          <div class="home-service-step-content-package-intro-right">
            <div class="home-service-step-content-package-intro-right-title">什么是常年法律顾问套餐?</div>
            <div class="home-service-step-content-package-intro-right-text">
              常年法律顾问套餐是一定期限内的预付费法律服务，可让您获得法律建议和一系列法律服务，这些服务的费用通常低于单项收费的律师服务。当您需要时，它可能是一种方便且具有成本效益的方式来获得法律帮助。<br><br>在牛法顾提供服务的每位商业律师都经过我们的审查和评估，以确保可信度、法律知识和相关经验。而且，由于顾问费用是统一费率，因此价格成本更容易预测。
            </div>
          </div>
        </div>

        <!-- 帮助方式 -->
        <div class="home-service-step-content-help-way">
          <div class="home-service-step-content-help-way-title">我们的法律顾问套餐可以帮助您的方式</div>
          <div class="home-service-step-content-help-way-content">
            <div class="home-service-step-content-help-way-content-text">
              在生命周期中，很多时候可靠的法律建议可以帮助您做出更明智的商业决策。通过常年法律顾问套餐服务，您将可以方便地从经验丰富的律师那里获得法律帮助，以便更好应对法律风险
            </div>
          </div>
        </div>

        <div class="home-service-step-content" style="flex-wrap: wrap;">
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/gongsichengli.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">公司成立</div>
            <div class="home-service-step-content-item-text">
              在成立新的中小微企业时，律师可以建议选择哪种企业类型，审查您的合资协议、章程和其他文件，并回答您的任何其他问题。</div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/jinrong.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">业务增长</div>
            <div class="home-service-step-content-item-text">
              随着您的业务规模扩大，律师可以就企业融资向您提供建议，帮助您做出关键的法律决策。</div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/jiuyewenti.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">日常业务</div>
            <div class="home-service-step-content-item-text">经验丰富的律师可以协助您处理企业正常的业务过程，例如日常咨询、审查合同或其他法律文件。
            </div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/ssfx.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">诉讼风险</div>
            <div class="home-service-step-content-item-text">如果您的公司因任何原因被起诉，商业律师可以指导您了解该怎么做以及如何应对诉讼的正确程序。
            </div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/hgx.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">合规性问题</div>
            <div class="home-service-step-content-item-text">为了保持您的企业信誉良好并避免行政处罚，顾问律师可以帮助您发现并解决合规问题。
            </div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/shuangshou.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">遗产规划及继承</div>
            <div class="home-service-step-content-item-text">当您有意规划遗产及处理继承事务时，律师可以提供建议，审查您的遗嘱、继承文件，并回答您的任何其他问题。</div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/fangdichan.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">房地产</div>
            <div class="home-service-step-content-item-text">当您准备购买或出售房屋、以及解决租赁协议中的房东和/或租户问题时，律师可以提供咨询。</div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/jiatingshiwu.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">家庭事务</div>
            <div class="home-service-step-content-item-text">当您结婚或婚姻状况产生变动时，我们的律师可以帮助您了解结婚、离婚、子女监护权和子女抚养费等法律事务的流程。</div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/jinrong.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">金融</div>
            <div class="home-service-step-content-item-text">有一位律师在您身边可以帮助您更好地了解复杂的财务事务，包括诉讼、债务、收款等。</div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/jiuyewenti.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">就业问题</div>
            <div class="home-service-step-content-item-text">经验丰富的律师可以为您提供重要指导，帮助您审查劳动合同、薪酬、福利、经济补偿金和解除合同等复杂情况。</div>
          </div>
          <div class="home-service-step-content-item">
            <div class="home-service-step-content-item-img">
              <img src="@/assets/home/qitashiwu.png" alt="">
            </div>
            <div class="home-service-step-content-item-title">其他个人事务</div>
            <div class="home-service-step-content-item-text">如果您发现自己正在处理个人法律事务，例如人身伤害、财产损失等，您可以咨询经验丰富的律师。</div>
          </div>
        </div>

        <div class="home-service-step-content-button">
          <div class="home-service-step-content-button-item">
            <div class="home-service-step-content-button-item-left">
              <!-- <RegionSelect v-model="selectedArea" @change="handleRegionChange" /> -->
              <el-select v-model="selectedServiceType" placeholder="请选择服务类型" style="width: 100%" class="custom-select">
                <el-option v-for="item in serviceTypes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="home-service-step-content-button-item-right" @click="handlePrivateLawyerClick()">
              开始您的法律顾问服务</div>
          </div>
        </div>

        <!-- 常见问题 -->
        <div class="home-service-step-content-question">
          <div class="home-service-step-content-question-title">常见问题解答</div>
          <div class="home-service-step-content-question-content">
            <div class="home-service-step-content-question-content-item" v-for="(item, index) in questionList"
              :key="index">
              <div class="headerBox" @click.stop="handleQuestionClick(item, index)" style="cursor: pointer;">
                <div class="home-service-step-content-question-content-item-title">{{ item.title }}</div>
                <div class="home-service-step-content-question-content-item-icon">
                  <img v-if="!item.show" src="@/assets/home/yous.png" alt="">
                  <img v-else src="@/assets/home/xia.png" alt="">
                </div>
              </div>
              <div class="home-service-step-content-question-content-item-text" v-if="item.show">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 需要服务吗 -->
    <!-- <div class="home-need-service-box">
      <div class="home-need-service">
        <div class="home-need-service-content">
          <div class="home-need-service-content-top">
            <div class="home-need-service-content-top-btn-left" @click="handleNeedService(1)" v-if="type == 0">
              探索个人顾问套餐服务</div>
            <div class="home-need-service-content-top-btn-left" @click="handleNeedService(0)" v-if="type == 1">
              探索企业顾问套餐服务</div>
            <div class="home-need-service-content-top-btn-right" @click="goCustomService"></div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import RegionSelect from '@/components/RegionSelect.vue'
import Footer from '@/components/FooterNav.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  name: 'HomePage',
  components: {
    RegionSelect,
    Footer,
    swiper,
    swiperSlide
  },
  data() {
    return {
      lList:[],
      swiperOption: {
        loop: false,
        initialSlide: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          hideOnClick: true,
          disabledClass: 'swiper-button-disabled'
        },
        allowTouchMove: true,
        watchSlidesProgress: true,
        on: {
          slideChange: function () {
            const swiper = this;
            const prevButton = swiper.navigation.prevEl;
            const nextButton = swiper.navigation.nextEl;

            if (swiper.activeIndex === 0) {
              prevButton.style.display = 'none';
            } else {
              prevButton.style.display = 'flex';
            }

            if (swiper.activeIndex === swiper.slides.length - 1) {
              nextButton.style.display = 'none';
            } else {
              nextButton.style.display = 'flex';
            }
          }
        }
      },
      selectedRegion: [],
      selectedArea: [],
      selectedServiceType: '',
      serviceTypes: [
        {
          value: 'company',
          label: '企业法律顾问'
        },
        {
          value: 'personal',
          label: '私人法律顾问'
        },
        {
          value: 'special',
          label: '专项服务'
        }
      ],
      comboList: [],
      description: '',
      comboDetail1: {},
      comboDetail2: {},
      type: localStorage.getItem('setMenuType') || 0,
      questionList: [
        {
          title: '我正在开始一项新业务:律师能帮我什么？',
          text: '律师可以协助您处理新业务中可能遇到的法律问题，包括公司注册、商标注册、合同起草等。',
          show: false
        },
        {
          title: '律师是否了解特定法律领域的知识?',
          text: '所有律师都经过严格的审查和评估，以确保他们具备必要的法律知识和经验。',
          show: false
        },
        {
          title: '我可以和我当地的律师谈谈吗?',
          text: '是的，您可以与您当地的律师进行咨询。',
          show: false
        },
        {
          title: '律师可以协助我起草诉状并向法院提交吗?',
          text: '是的，律师可以协助您起草诉状并向法院提交。',
          show: false
        },
        {
          title: '法律顾问套餐有哪些限制?',
          text: '法律顾问套餐通常有以下限制：\n1. 服务范围：法律顾问套餐通常有一定的服务范围，超出范围的服务可能需要额外付费。\n2. 服务时间：法律顾问套餐通常有一定的服务时间限制，超出时间的服务可能需要额外付费。\n3. 服务方式：法律顾问套餐通常有一定的服务方式限制，超出方式的服务可能需要额外付费。',
          show: false
        }
      ]
    }
  },

  mounted() {
    this.getLsList()
    // this.type = localStorage.getItem('setMenuType') || 0;
    // this.getComboList();
  },
  methods: {

    async getLsList() {
      try {
        const res = await this.$api.home.getLsListApi()
        if (res.code == 200) {
          this.lList = res.data;
        }
      } catch (error) {
        this.$http.handleError(error)
      }
    },

    goAboutUs() {
      this.$router.push({
        path: '/agreement',
        query: { id: 14, temp: new Date().getTime() }
      })
    },
    handleGoPackClick(type) {
      if (type == 'COMPANY') {
        this.$router.push({
          path: '/packageIntroduction',
        })
      } else if (type == 'USER') {
        this.$router.push({
          path: '/packagePrivate',
        })
      } else {
        this.$router.push({
          path: '/packageDetailsForDz',
        })
      }
    },
    // 获取企业法律套餐列表
    async getComboList() {
      try {
        let res = await this.$api.home.getComboList({ comboType: this.type == 0 ? 'COMPANY' : 'USER' })
        if (res.code == 200) {
          this.comboList = res.rows || [];
          if (this.comboList.length > 0) {
            this.description = this.comboList[0].comboRemark || '';
            this.comboList.forEach((item, index) => {
              this.getComboDetail(item.id, index + 1)
            })
          }
        }
      } catch (error) {
        this.$http.handleError(error)
      }
    },

    // 获取套餐详情
    async getComboDetail(id, type) {
      try {
        let res = await this.$api.home.getComboDetail({ id })
        if (res.code == 200) {
          if (type == 1) {
            this.comboDetail1 = res.data || {};
          } else {
            this.comboDetail2 = res.data || {};
          }
        }
      } catch (error) {
        this.$http.handleError(error)
      }
    },
    goCustomService() {
      this.$router.push({
        path: '/packageDetailsForDz'
      })
    },
    handleNeedService(type) {
      localStorage.setItem('setMenuType', type)
      window.location.reload();
    },
    handleQuestionClick(item, index) {
      item.show = !item.show
      this.questionList.forEach((items, indexs) => {
        if (indexs != index) {
          items.show = false
        }
      })
    },
    handlePrivateLawyerClick() {
      if (!this.selectedServiceType) {
        this.$toast.warning('请选择服务类型')
        return
      }
      if (this.selectedServiceType == 'company') {
        this.$router.push({
          path: '/packageIntroduction',
        })
      } else if (this.selectedServiceType == 'personal') {
        this.$router.push({
          path: '/packagePrivate',
        })
      } else {
        this.$router.push({
          path: '/packageDetailsForDz',
        })
      }
    },
    // 选择套餐地区
    handleRegionChangeForCombo({ codes, names }, item) {
      console.log(codes, '选中的地区代码')
      console.log(names, '选中的地区名称')
      console.log(item, '选中的套餐')
    },
    handleRegionChange({ codes, names }) {
      console.log('选中的地区代码：', codes)
      console.log('选中的地区名称：', names)
    },
    handleAreaChange({ codes, names }) {
      console.log('选中的地区代码：', codes)
      console.log('选中的地区名称：', names)
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  width: 100%;

  // 添加自定义 select 样式
  :deep(.custom-select) {
    .el-input__inner {
      border: none;
      background: transparent;
      height: 100%;
      line-height: 64px;
      font-size: 16px;
      color: #333;
      padding-left: 0;
    }

    .el-input__suffix {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .home-banner-box {
    width: 100%;

    .home-banner {
      margin: 0 auto;
      width: 100%;
      height: 782px;
      position: relative;

      .website-intro {
        position: absolute;
        top: 0;
        width: 100%;
        height: auto;
        box-sizing: border-box;
        z-index: 9;

        .website-intro-box {
          text-indent: 2em;
          padding: 40px 610px 0 0;
          width: 100%;
          max-width: 1304px;
          margin: 0 auto;
          box-sizing: border-box;
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
        }
      }

      .swiper-container-box {
        width: 100%;
        max-width: 1980px;
        padding: 0;
        height: 782px;
        margin: 0 auto;
        position: relative;

        /* 自定义分页器样式 */
        :deep(.swiper-pagination) {
          bottom: 30px;

          .swiper-pagination-bullet {
            width: 12px;
            height: 12px;
            background: rgba(255, 255, 255, 0.5);
            opacity: 1;

            &-active {
              background: #458BFF;
            }
          }
        }

        /* 自定义前进后退按钮样式 */
        :deep(.swiper-button-prev),
        :deep(.swiper-button-next) {
          width: 50px;
          height: 50px;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 50%;

          &:after {
            font-size: 20px;
            color: #fff;
          }

          &:hover {
            background: rgba(0, 0, 0, 0.5);
          }

          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 50%;
            height: auto;
          }
        }

        :deep(.swiper-button-prev) {
          left: 30px;
        }

        :deep(.swiper-button-next) {
          right: 30px;
        }

        .home-banner-content-box {
          width: 100%;
          height: 100%;
          position: relative;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: auto;
            height: 100%;
          }

          .home-banner-content {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 1304px;
            height: 100%;
            margin: 0 auto;
            overflow: hidden;

            .home-banner-content-desc {
              width: 684px;
              height: 493px;
              background: #F5F2EE;
              border-radius: 12px;
              margin-top: 150px;
              padding: 40px;

              .home-banner-content-desc-title {
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 48px;
                color: #000000;
                line-height: 76px;
              }

              .home-banner-content-desc-text {
                margin-top: 35px;
                width: 480px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #000000;
                line-height: 32px;
              }

              .home-banner-content-desc-button {
                margin-top: 95px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .left {
                  width: 224px;
                  height: 58px;
                  background: #FFFFFF;
                  border-radius: 8px;
                  border: 1px solid #458BFF;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }

                .right {
                  cursor: pointer;
                  width: 375px;
                  height: 58px;
                  background: #458BFF;
                  border-radius: 8px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 600;
                  font-size: 16px;
                  color: #FFFFFF;
                  line-height: 58px;
                  text-align: center;
                }

              }
            }
          }
        }


      }



    }
  }

  .home-why-choose-box {
    width: 100%;

    .home-why-choose {
      padding: 66px 0;
      width: 1304px;
      height: 496px;
      margin: 0 auto;
      background: #ffffff;

      .home-why-choose-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #000000;
        line-height: 40px;
      }

      .home-why-choose-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .home-why-choose-content-item {
          width: 415px;
          height: 340px;
          display: flex;
          flex-direction: column;

          .home-why-choose-content-item-img {
            margin-top: 30px;
            width: 72px;
            height: 72px;
            background: url('@/assets/home/spmoney.png') no-repeat center center;
            background-size: 100% 100%;
          }

          .home-why-choose-content-item-title {
            margin-top: 25px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 24px;
            color: #000000;
            line-height: 32px;
          }

          .home-why-choose-content-item-text {
            margin-top: 30px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 34px;
          }
        }

        .home-why-choose-content-item:nth-child(2) {
          .home-why-choose-content-item-img {
            background: url('@/assets/home/dengpao.png') no-repeat center center;
            background-size: 100% 100%;
          }
        }

        .home-why-choose-content-item:nth-child(3) {
          .home-why-choose-content-item-img {
            background: url('@/assets/home/woshou.png') no-repeat center center;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  .home-choose-private-lawyer-box {
    width: 100%;

    .home-choose-private-lawyer-bg {
      margin: 0 auto;
      width: 100%;
      height: 724px;
      background: #F5F2EE;

      .home-choose-private-lawyer {
        padding: 66px 0;
        width: 1304px;
        height: 724px;
        margin: 0 auto;

        .home-choose-private-lawyer-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #000000;
          line-height: 40px;
          text-align: center;
        }

        .home-choose-private-lawyer-content {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 90px;

          .home-choose-private-lawyer-content-item {
            width: 636px;
            height: 448px;
            background-color: #ffffff;
            border-radius: 8px;
            padding: 48px;

            .home-choose-private-lawyer-content-item-user {
              display: inline-block;
              padding-right: 10px;
              background: url('@/assets/home/Vector.png') no-repeat 10px center #F5F2EE;
              background-size: 22px 22px;
              padding: 3px 10px 3px 40px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 20px;
              color: #000000;
              border-radius: 8px;
            }

            .home-choose-private-lawyer-content-item-title {
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 22px;
              color: #000000;
              line-height: 60px;
              padding-bottom: 15px;
              border-bottom: 2px solid rgba(0, 0, 0, 0.1);
            }

            .home-choose-private-lawyer-content-item-price {
              margin-top: 20px;

              .home-choose-private-lawyer-content-item-price-top {
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #000000;
                line-height: 28px;

                span {
                  font-size: 14px;
                  font-weight: 400;
                }
              }

              .home-choose-private-lawyer-content-item-price-bottom {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #000000;
                line-height: 24px;
              }
            }

            .home-choose-private-lawyer-content-item-area {
              width: 100%;
              height: 59px;
              background: #FFFFFF;
              border-radius: 8px;
              border: 1px solid #458BFF;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 30px;
            }

            .home-choose-private-lawyer-content-item-button {
              width: 100%;
              height: 59px;
              background: #458BFF;
              border-radius: 8px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #FFFFFF;
              line-height: 59px;
              text-align: center;
              margin-top: 30px;
              cursor: pointer;
            }
          }
        }
      }
    }

  }

  .home-video-box {
    width: 100%;

    .home-video {
      width: 1304px;
      min-height: 1041px;
      margin: 0 auto;
      padding: 73px 0;

      .home-video-content {
        width: 100%;

        .home-video-content-item {
          width: 100%;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;

          .home-video-content-item-des {
            width: 584px;

            .home-video-content-item-des-title {
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 32px;
              color: #000000;
              line-height: 40px;
            }

            .home-video-content-item-des-text {
              .home-video-content-item-des-text-item {
                .home-video-content-item-des-text-item-title {
                  margin-top: 15px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 500;
                  font-size: 18px;
                  color: #000000;
                  line-height: 28px;
                }

                .home-video-content-item-des-text-item-text {
                  margin-top: 14px;
                  background: url('@/assets/home/lingxing.png') no-repeat 0px 6px;
                  background-size: 12px 12px;
                  padding-left: 18px;
                }
              }
            }
          }

          .home-video-content-item-video {
            width: 640px;
            height: 360px;
            background: url('@/assets/home/video.png') no-repeat center center;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  .home-lawyer-info-box {
    width: 100%;

    .home-lawyer-info {
      width: 100%;
      min-height: 908px;
      margin: 0 auto;
      background: #F5F2EE;

      .home-lawyer-info-center {
        width: 1304px;
        padding: 66px 0;
        height: 100%;
        margin: 0 auto;

        .home-lawyer-info-center-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 30px;
          color: #000000;
          line-height: 36px;
        }

        .home-lawyer-info-center-text {
          margin-top: 17px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #000000;
          line-height: 36px;
        }

        .home-lawyer-info-center-list {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 19px;

          .home-lawyer-info-center-list-item {
            width: 406px;
            min-height: 670px;
            background: #ffffff;
            border-radius: 8px;
            overflow: hidden;

            .home-lawyer-info-center-list-item-img {
              width: 100%;
              height: 406px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .home-lawyer-info-center-list-item-description {
              padding: 26px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #000000;
              line-height: 32px;
            }
          }
        }
      }
    }
  }

  .home-service-step-box {
    width: 100%;
    padding: 69px 0;

    .home-service-step {
      width: 1304px;
      min-height: 300px;
      margin: 0 auto;

      .home-service-step-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #000000;
        line-height: 40px;
      }

      .home-service-step-content {
        width: 100%;
        display: flex;
        justify-content: space-between;

        &::after {
          content: '';
          width: calc((100% - 40px) / 3);
        }

        .home-service-step-content-item {
          width: 380px;
          background: #ffffff;
          border-radius: 8px;

          .home-service-step-content-item-img {
            width: 66px;
            height: 66px;
            margin-top: 47px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .home-service-step-content-item-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 24px;
            color: #000000;
            line-height: 32px;
            margin-top: 23px;
          }

          .home-service-step-content-item-text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #000000;
            line-height: 32px;
            margin-top: 20px;
          }
        }
      }

      .home-service-step-content1 {
        width: 100%;
        display: flex;
        justify-content: space-between;

        // &::after {
        //   content: '';
        //   width: calc((100% - 40px) / 3);
        // }

        .home-service-step-content-item {
          width: 380px;
          background: #ffffff;
          border-radius: 8px;

          .home-service-step-content-item-img {
            width: 66px;
            height: 66px;
            margin-top: 47px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .home-service-step-content-item-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 24px;
            color: #000000;
            line-height: 32px;
            margin-top: 23px;
          }

          .home-service-step-content-item-text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #000000;
            line-height: 32px;
            margin-top: 20px;
          }
        }
      }

      .home-service-step-content-button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 72px;
        margin-top: 70px;

        .home-service-step-content-button-item {
          width: 535px;
          height: 72px;
          background: #ffffff;
          border-radius: 36px;
          border: 4px solid #458BFF;
          display: flex;
          align-items: center;
          justify-content: space-between;
          overflow: hidden;

          .home-service-step-content-button-item-left {
            flex: 1;
            padding-left: 27px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .home-service-step-content-button-item-right {
            width: 223px;
            height: 100%;
            background: #458BFF;
            border-radius: 36px;
            cursor: pointer;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 68px;
            text-align: center;
          }
        }

      }

      .home-service-step-content-package-intro {
        width: 100%;
        margin-top: 145px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .home-service-step-content-package-intro-left {
          width: 507px;
          height: 284px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .home-service-step-content-package-intro-right {
          width: 638px;

          .home-service-step-content-package-intro-right-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 32px;
            color: #000000;
            line-height: 40px;
            margin-bottom: 30px;
          }

          .home-service-step-content-package-intro-right-text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 32px;
          }
        }
      }

      .home-service-step-content-help-way {
        width: 100%;
        margin-top: 124px;

        .home-service-step-content-help-way-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #000000;
          line-height: 40px;
          text-align: center;
        }

        .home-service-step-content-help-way-content {
          width: 100%;
          margin-top: 30px;

          .home-service-step-content-help-way-content-text {
            margin: 0 auto;
            width: 837px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 32px;
            text-align: center;
          }
        }
      }

      .home-service-step-content-question {
        width: 100%;
        margin-top: 114px;

        .home-service-step-content-question-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 30px;
          color: #000000;
          line-height: 36px;
        }

        .home-service-step-content-question-content {
          width: 100%;
          margin-top: 33px;

          .home-service-step-content-question-content-item {
            width: 100%;
            min-height: 84px;
            border-bottom: 2px solid #000000;

            .headerBox {
              width: 100%;
              height: 84px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            .home-service-step-content-question-content-item-text {
              padding-bottom: 20px;
              width: 90%;
            }

            .home-service-step-content-question-content-item-title {
              cursor: pointer;
              height: 84px;
              line-height: 84px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 18px;
              color: #000000;
            }

            .home-service-step-content-question-content-item-icon {
              cursor: pointer;
              width: 30px;
              height: 30px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

        }
      }
    }
  }

  .home-need-service-box {
    width: 100%;

    .home-need-service {
      width: 100%;
      margin: 0 auto;
      background: url('@/assets/home/footer.png') no-repeat center center;
      background-size: contain;
      height: 460px;

      .home-need-service-content {
        width: 1304px;
        height: 100%;
        margin: 0 auto;
        position: relative;

        .home-need-service-content-top-btn-left {
          position: absolute;
          left: 0;
          top: 273px;
          width: 250px;
          height: 65px;
          cursor: pointer;
          background-color: #000000;
          color: #FFFFFF;
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          line-height: 65px;
          text-align: center;
          border-radius: 32px;
        }

        .home-need-service-content-top-btn-right {
          position: absolute;
          left: 280px;
          top: 273px;
          width: 226px;
          height: 60px;
          cursor: pointer;
        }
      }
    }
  }

  .legalInstrument-extend-box {
    width: 100%;
    height: 298px;
    padding: 60px 0;
    background: url('@/assets/home/bgs2.png') no-repeat center center;
    background-size: 1980px 298px;

    .legalInstrument-extend-content {
      width: 1304px;
      height: 100%;
      margin: 0 auto;
      position: relative;

      .legalInstrument-extend-btn {
        width: 147px;
        height: 48px;
        position: absolute;
        top: 128px;
        left: 11px;
        cursor: pointer;
      }
    }
  }
}
</style>